import { useEffect, useState } from "react";
import styles from "./ProductView.module.css";
import Skeleton from "./Skeleton";
import Riferimenti from "./Riferimenti";
import Documenti from "./Documenti";
import BottoniProcessi from "./ButtonProcessi";
import Popup from "./Popup";
import { REACT_APP_PDA, REACT_APP_PDT, REACT_APP_NPDA } from "../../constants";

type Props = {
  data: any;
  isLoading: boolean;
  onClick: () => void;
};

// Componente principale ProductView
function ProductView({ data, onClick, isLoading }: Props) {
  const [iterDigitale, setIterDigitale] = useState([]);
  const [prenota, setPrenota] = useState([]);
  const [paga, setPaga] = useState([]);
  const [popupData, setPopupData] = useState(null);

  // Effetto per inizializzare i processi a partire dai dati forniti
  useEffect(() => {
    if (data) {
      const processi = data.processi;
      const currIter = [];
      const currPrenota = [];
      const currPaga = [];
      if (processi.length) {
        processi.forEach((p) => {
          if (
            window.location.origin.includes(REACT_APP_PDT) &&
            p.tipologia === 0
          ) {
            currIter.push(p);
          }
          if (
            (window.location.origin.includes(REACT_APP_PDT) ||
              window.location.origin.includes(REACT_APP_PDA)) &&
            p.tipologia === 1
          ) {
            currPrenota.push(p);
          }
          if (
            (window.location.origin.includes(REACT_APP_PDT) ||
              window.location.origin.includes(REACT_APP_PDA)) &&
            p.tipologia === 2
          ) {
            currPaga.push(p);
          }
        });
      }
      setIterDigitale(currIter);
      setPrenota(currPrenota);
      setPaga(currPaga);
    }
  }, [data]);

  const isAtListOneButton =
    iterDigitale.length > 0 || prenota.length > 0 || paga.length > 0;

  
  //open popup if processi.length !== 1 see ButtonProcessi component
  const handleButtonClick = (processi: any[], title: string) => {
    if (processi.length === 1) {
      window.open(processi[0].link, "_blank");
    } else {
      setPopupData({ title, processes: processi });
    }
  };

  const closePopup = () => {
    setPopupData(null);
  };

  const hasButtons =
    iterDigitale.length > 0 || prenota.length > 0 || paga.length > 0;

  return (
    <div className={styles["container-prod"]}>
      <span className={styles["span-prod"]}>
        {isLoading ? <Skeleton /> : data?.titolo}
      </span>
      <div className={styles["data-wrapper"]}>
        <span className={styles["span-prod"]}>Descrizione</span>
        <span className={styles["span-desc"]}>
          {isLoading ? <Skeleton /> : data?.descrizione}
        </span>
      </div>
	  {isLoading ? (
	      <div className={styles["data-wrapper"]}>
	        <span className={styles["span-prod"]}>Ulteriori dettagli</span>
	        <span className={styles["span-desc"]}><Skeleton /></span>
	      </div>
		  ) : (
			data?.ulterioriDettagli !== null && (
				<div className={styles["data-wrapper"]}>
					<span className={styles["span-prod"]}>Ulteriori dettagli</span>
					<span className={styles["span-desc"]}>{data?.ulterioriDettagli}</span>
				</div>
				)
	  )}
      <div className={styles["data-wrapper"]}>
        <span className={styles["span-prod"]}>Normativa</span>
        <span className={styles["span-desc"]}>
          {isLoading ? <Skeleton /> : <Riferimenti data={data} />}
        </span>
      </div>
      <div className={styles["data-wrapper"]}>
        <span className={styles["span-prod"]}>Documenti per la richiesta</span>
        <span className={styles["span-desc"]}>
          {isLoading ? <Skeleton /> : <Documenti data={data} type="input" />}
        </span>
      </div>
      <div className={styles["data-wrapper"]}>
        <span className={styles["span-prod"]}>Documenti rilasciati</span>
        <span className={styles["span-desc"]}>
          {isLoading ? <Skeleton /> : <Documenti data={data} type="output" />}
        </span>
      </div>
      <div className={styles["data-wrapper"]}>
        <span className={styles["span-prod"]}>Competenza territoriale</span>
        <span className={styles["span-desc"]}>
          {isLoading ? <Skeleton /> : data?.competenzaTerritoriale}
        </span>
      </div>
      <div className={styles["data-wrapper"]}>
        <span className={styles["span-prod"]}>
          Codice tariffa nazionale (senza esenzioni)
        </span>
        <span className={styles["span-desc"]}>
          {isLoading ? <Skeleton /> : data?.codiciTariffaFallback}
        </span>
      </div>
      <div className={styles["data-wrapper"]}>
        <span className={styles["span-prod"]}>Importo</span>
        <span className={styles["span-desc"]}>
          {isLoading ? (
            <Skeleton />
          ) : (
            <>
              {data?.importoDiritti && (
                <div>Diritti: {data.importoDiritti} </div>
              )}
              {data?.importoBolli && <div>Bolli: {data.importoBolli} </div>}
              {data?.importoFallback &&
                !data?.importoDiritti &&
                !data?.importoBolli && <div> {data.importoFallback} </div>}
            </>
          )}
        </span>
      </div>
      <hr />
	  {window.location.origin.includes(REACT_APP_PDA) && !REACT_APP_NPDA && paga.length > 0 && (
		  <div className={styles["data-wrapper"]}>
		  	<span className={styles["span-prod-right"]}>Per procedere al pagamento e/o alla prenotazione effettuare prima il{" "} 
			<a href="https://www.ilportaledellautomobilista.it/web/portale-automobilista/loginspid"
				target="_blank"
				rel="noopener noreferrer"
				className={styles["login-link"]}>
			log-in
			</a>.
			</span>
		  </div>
	  )}
      <div
        className={styles["btn-container"]}
        style={{
          display: "flex",
          justifyContent: isAtListOneButton ? "space-between" : "center",
        }}
      >
        <button
          onClick={onClick}
          type="button"
          className="btn btn-primary btn-xs"
        >
          Torna indietro
        </button>

        {hasButtons && (
          <BottoniProcessi
            iterDigitale={iterDigitale}
            prenota={prenota}
            paga={paga}
            onButtonClick={handleButtonClick}
          />
        )}
      </div>
      {popupData && (
        <Popup
          title={popupData.title}
          processes={popupData.processes}
          onClose={closePopup}
        />
      )}
    </div>
  );
}
export default ProductView;
